import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

function ImageDragger({ searchedResult, files, onFileChange }) {
  const handleBeforeUpload = (file) => {
    if (!searchedResult) {
      message.warning("Please enter an address before uploading images.");
      return false;
    }
    return false;
  };

  return (
    <Dragger
      multiple
      disabled={!searchedResult}
      beforeUpload={handleBeforeUpload}
      onChange={onFileChange}
      fileList={files}
      showUploadList={false}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        Click or drag images to this area to upload
      </p>
      <p className="ant-upload-hint">
        {searchedResult
          ? "Address: " + searchedResult
          : "Please enter an address before uploading images."}
      </p>
    </Dragger>
  );
}

export default ImageDragger;
